import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { currency } from 'constants';

// Shared EUR price treatment for the cart page, cart lines and mini cart.
const LEAD_SIZE = { sm: '15px', md: '17px', lg: '20px' };
// Inline layout steps the amount down on narrow screens so it stays inside the summary card.
const INLINE_NUM = {
  sm: { xs: '13px', sm: '15px' },
  md: { xs: '14px', sm: '17px' },
  lg: { xs: '16px', sm: '20px' }
};
const INLINE_CUR = {
  sm: { xs: '9px', sm: '11px' },
  md: { xs: '10px', sm: '12px' },
  lg: { xs: '11px', sm: '13px' }
};

const PriceStack = ({ amount, size = 'md', align = 'flex-end', inline = false }) => {
  const eur = Number(amount || 0).toFixed(2);

  if (inline) {
    const numSx = {
      fontSize: INLINE_NUM[size],
      fontWeight: 600,
      color: 'price.main',
      fontVariantNumeric: 'tabular-nums'
    };
    // Currency code: a step smaller than the amount, and muted so the number leads.
    const curSx = {
      fontSize: INLINE_CUR[size],
      fontWeight: 500,
      color: 'text.secondary',
      ml: '3px'
    };
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: align,
          gap: { xs: '5px', sm: '8px' },
          whiteSpace: 'nowrap'
        }}>
        <Box component="span" sx={numSx}>
          {eur}
          <Box component="span" sx={curSx}>
            {currency.EUR}
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: align }}>
      <Box
        component="span"
        sx={{
          fontSize: LEAD_SIZE[size],
          fontWeight: 600,
          color: 'price.main',
          lineHeight: 1.25,
          fontVariantNumeric: 'tabular-nums'
        }}>
        {eur} {currency.EUR}
      </Box>
    </Box>
  );
};

PriceStack.propTypes = {
  amount: PropTypes.number.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  align: PropTypes.oneOf(['flex-start', 'flex-end']),
  inline: PropTypes.bool
};

export default PriceStack;
